import { render, staticRenderFns } from "./ForumGroup.vue?vue&type=template&id=08b0a908&scoped=true&"
import script from "./ForumGroup.vue?vue&type=script&lang=js&"
export * from "./ForumGroup.vue?vue&type=script&lang=js&"
import style0 from "./ForumGroup.vue?vue&type=style&index=0&id=08b0a908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0a908",
  null
  
)

export default component.exports